import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LogService } from '@prekog/common-ui';

import { FestivalStatisticTotals } from '../../shared/models/festival-statistic-totals.model';
import { FestivalStatistics } from '../../statistics/festivalstatistic/festivalstatistics';
import { CalculateStatisticTotalsUseCase } from '../../shared/use-cases/calculate-statistic-totals.usecase';

@Injectable({
    providedIn: 'root'
})
export class CalculateFestivalStatisticTotalsUseCase extends CalculateStatisticTotalsUseCase<FestivalStatistics, FestivalStatisticTotals> {
    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override extractRowTotals(row: FestivalStatistics): FestivalStatisticTotals {
        return {
            movedOut: row.movedOutQuantity ?? 0,
            sold: row.soldQuantity ?? 0,
            returned: row.returnedQuantity ?? 0
        };
    }
}
